<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <g transform="translate(-1106.501 -614.396)">
      <g>
        <rect
          width="20"
          height="18"
          rx="2"
          transform="translate(1106.501 616.396)"
          fill="none"
        />
        <path
          d="M1124.5,634.4h-16a2,2,0,0,1-2-2v-14a2,2,0,0,1,2-2h16a2,2,0,0,1,2,2v14A2,2,0,0,1,1124.5,634.4Zm-16-17a1,1,0,0,0-1,1v14a1,1,0,0,0,1,1h16a1,1,0,0,0,1-1v-14a1,1,0,0,0-1-1Z"
        />
      </g>
      <g>
        <rect
          width="1"
          height="5"
          transform="translate(1111.501 614.396)"
          fill="none"
        />
        <path
          d="M1112,619.4a.5.5,0,0,1-.5-.5v-4a.5.5,0,0,1,1,0v4A.5.5,0,0,1,1112,619.4Z"
        />
      </g>
      <g>
        <rect
          width="1"
          height="5"
          transform="translate(1120.501 614.396)"
          fill="none"
        />
        <path
          d="M1121,619.4a.5.5,0,0,1-.5-.5v-4a.5.5,0,0,1,1,0v4A.5.5,0,0,1,1121,619.4Z"
        />
      </g>
      <g>
        <rect
          width="20"
          height="1"
          transform="translate(1106.501 621.396)"
          fill="none"
        />
        <rect
          width="19"
          height="1"
          transform="translate(1107.001 621.396)"
        />
      </g>
      <path
        d="M1115.411,631.239a.5.5,0,0,1-.339-.133l-3.531-3.26a.5.5,0,0,1,.678-.735l3.195,2.951,5.928-5.375a.5.5,0,0,1,.672.74l-6.267,5.682A.5.5,0,0,1,1115.411,631.239Z"
      />
    </g>
  </svg>
</template>
